import { VideoPinComponent, VideoSource, Size, Vector } from '../../models';
import { newBox, newSize } from '../geometry';
import { defaultOrder } from '../order';
import { randomId } from '../random-id';
import { initialPinComponentPosition } from './pin-component';

type VideoPinComponentProps = {
  source?: VideoSource;
  sourceId?: string;
  position?: Vector;
  settings?: Partial<VideoPinComponent['settings']>;
  size?: Size;
  order?: string;
  id?: string;
};

export const minimumVideoComponentSize = newSize(480, 270);

export function newVideoPinComponent({
  position = initialPinComponentPosition,
  size = minimumVideoComponentSize,
  order = defaultOrder,
  settings,
  source,
  sourceId,
  id,
}: VideoPinComponentProps): VideoPinComponent {
  if (size.width < minimumVideoComponentSize.width || size.height < minimumVideoComponentSize.height) {
    throw new Error('Video component size is too small');
  }
  return {
    type: 'VIDEO',
    id: id || randomId(),
    settings: {
      ...settings,
      source: source || undefined,
      sourceId: sourceId || undefined,
    },
    layout: newBox(position, size, 0, true),
    order,
  };
}
